import {post} from '@/utils/request';
import{erpserver,attendanceserver} from '@/utils/baseUrl';
//查询列表
export async function search(params) {
     return post(attendanceserver+'/kq/jbList', params, true)
}
// //新增
// export async function get(params) {
//     return post(erpserver+'/kq/addEditJq', params, true)
// }
// //编辑
// export async function hold (params) {
//     return post(erpserver+'/kq/addEditJq', params, true)
// }
//保存
export async function save (params) {
    return post(attendanceserver+'/kq/addEditJq', params, true)
}
export async function jbType (params) {
    return post(attendanceserver+'/kq/jbType', params, true)
}
export async function jbEditType (params) {
    return post(attendanceserver+'/kq/jbEditType', params, true)
}